<template>
  <mailbox-settings-layout :id="id" :name="name">
    <el-card class="mailbox-settings-custom-fields">
      <template #header>
        <h3>Custom Fields</h3>
      </template>
      <custom-fields-manager :id="id" entity-type="mailbox" @name-loaded="name = $event" />
    </el-card>
  </mailbox-settings-layout>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

export default defineComponent({
  name: 'MailboxSettingsCustomFields',

  components: {
    MailboxSettingsLayout,
  },

  data() {
    return {
      name: '',
    }
  },

  head(): any {
    return {
      title: `Custom Fields - ${this.name}`,
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },
})
</script>
